<template>
  <div>
    <v-card
      v-if="
        checkaccessdata.is_viewer == false &&
        checkaccessdata.is_checker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card elevation="0" v-else>
      <v-row class="mt-1">
        <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
          <v-data-table dense :headers="headersDept" :items="deptartmrntdata">
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{
                deptartmrntdata.indexOf(item) + 1
              }}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div class="green--text caption" v-if="item.status == '1'">
                Active
              </div>
              <div class="red--text caption" v-if="item.status == '0'">
                Inactive
              </div>
            </template>
            <template v-slot:top class="mb-n16">
              <v-card
                :width="isMobile ? '300' : 'auto'"
                elevation="1"
                class="mb-5 ml-2 mr-2"
                rounded="xl"
              >
                <v-row>
                  <v-col cols="12" lg="11" xl="11" md="11" sm="12" xs="12">
                    <v-card-title class="ml-n2">
                      <span class="primary--text Heading 6"
                        >Organization Budget
                      </span>
                    </v-card-title>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span class="green--text ml-2 Heading 6">
                      <b class="primary--text">Selected Duration :</b>
                      {{ getdurationmon() }}
                    </span>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span class="green--text ml-2 Heading-1">
                      <b class="primary--text">Total Budget :</b>
                      {{ budgetavailaible.total_budget }}
                    </span>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span class="green--text ml-2 Heading 6">
                      <b class="primary--text">Allocated Budget :</b>
                      {{ budgetavailaible.allocated_budget }}
                    </span>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span class="green--text ml-2 Heading 6">
                      <b class="primary--text">Unallocated Budget :</b>
                      {{ budgetavailaible.unallocated_budget }}
                    </span>
                  </v-col></v-row
                >
              </v-card>
            </template>
            <template v-slot:[`item.Actions`]="{ item }">
              <v-icon
                small
                class="assign"
                color="primary"
                @click="assignbudget(item)"
                >mdi-plus</v-icon
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog persistent v-model="addBudGetDialoge" width="500">
      <v-toolbar dark class="gradient-bg2">
        <v-toolbar-items>
          <v-toolbar-title class="white--text titcss ml-n1 mt-4"
            >Add Budget</v-toolbar-title
          >
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-btn class text dark @click="closeuserdialog()">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-divider></v-divider>
        <v-form ref="form">
          <v-row class="mt-8 mx-7">
            <v-select
              label="Select Department"
              v-model="Department"
              :items="depts"
              dense
              outlined
            ></v-select>
          </v-row>
          <v-row class="mx-7">
            <v-text-field
              v-model="moneyD"
              label="Add Budget to Department"
              dense
              outlined
            ></v-text-field>
          </v-row>
          <v-row class="mx-7">
            <v-text-field
              disabled
              placeholder="Duration Selected: Monthly"
              v-model="durationD"
              dense
              outlined
            ></v-text-field>
          </v-row>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="black white--text" rounded>Add Budget</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="userdialog" width="600px">
      <v-form ref="userdialogform">
        <v-card class="overflow-hidden">
          <v-toolbar dark dense class="header">
            <v-icon>mdi-currency-btc</v-icon>
            <span class="ml-3">Assign Budget to Department</span>
            <v-spacer></v-spacer>
            <v-btn text dark @click="userdialog = false">
              <v-icon color="white" small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-row class="pa-4 mt-2 mb-n7">
            <v-col cols="12" md="12">
              <v-text-field
                label="Department Name"
                v-model="departmentName"
                outlined
                dense
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="12" sm="3" class="mt-n3">
              <v-text-field
                maxlength="10"
                label="Enter Budget"
                v-model="budget"
                outlined
                dense
                :hint="max_amount"
                persistent-hint
                :rules="rulename"
                :color="redcolor"
                @keypress="isNumber(event)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary white--text" @click="createdeptbudget"
              >Assign</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="budgetwarningdialog" max-width="500">
      <v-card>
        <v-card-title class="font-weight-bold text-h6">
          Your Available Budget To Allocate is
          <span class="green--text ml-2 Heading 6">
            {{ budgetavailaible.unallocated_budget }}(MYR)
          </span>
        </v-card-title>

        <v-card-text class="font-weight-medium">
          Dear Customer, The budget
          <span class="red--text Heading 6"> {{ budget }}(MYR) </span>
          your trying to allocate is Exceeding to available budget.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="budgetwarningdialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  data: () => ({
    checkaccessdata: {},
    moneyD: "",
    Department: "",
    dptbudgetid: "",
    total_budget: "",
    rulename: [(v) => !!v || "required"],
    depts: ["Sales", "Marketing"],
    departmrnts: ["sales", "marketing"],
    budget: "",
    empName: "",
    deptartmrntdata: [],
    empNameList: ["Athish Sagar Singh", "Anusha S"],
    departmentName: "",
    userdialog: false,
    dialog: false,
    orgbudgetdeatils: "",
    redcolor: "",
    error: false,
    depdata: "",
    budgetavailaible: "",
    dptbudgetiddialog: false,
    budgetwarningdialog: false,
    editdialog: false,
    durationD: "",
    menu: false,
    max_amount: "",

    desserts: [
      {
        Name: "Sales",
        Budget: "1000",
      },
      {
        Name: "Marketing",
        Budget: "1500",
      },
    ],
    headersDept: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "DEPARTMENT NAME",
        value: "department_name",
      },
      {
        text: "DESCRIPTION",
        value: "department_description",
      },
      {
        text: "BUDGET",
        value: "total_budget",
      },
      {
        text: "STATUS",
        value: "status",
      },
      {
        text: "ACTIONS",
        value: "Actions",
      },
    ],
    search: "",
    addBudGetDialoge: false,
  }),
  created() {
    this.checkaccess();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    budget(val) {
      // console.log(val);
      if (
        this.dptbudgetid == "0" &&
        Number(val) > Number(this.unallocatedbudget)
      ) {
        this.max_amount = `Your Budget is More than Unallocated Budget`;
        this.redcolor = "red";
        this.error = true;
      } else {
        this.max_amount = ``;
        this.redcolor = "";
        this.error = false;
      }
    },
    // ${this.unallocatedbudget}
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "BUDGET",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getdepartment();
        this.getorgbudgetdeatils();
      }
    },
    // save() {
    //   this.createdeptbudget();
    //   console.log("Data saved");
    // },
    // open() {
    //   console.log("Dialog opened");
    // },
    // close() {
    //   console.log("Dialog closed");
    // },
    cancel() {
      // console.log("cancelled");
      // this.snack = true
      // this.snackColor = 'error'
      // this.snackText = 'Canceled'
    },
    async getorgbudgetdeatils() {
      var inputData = {
        method_name: "BUDGET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETORG",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      //   console.log("getorgeData", responseData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var self = this;
          responseData.data.data.forEach(function (ele) {
            if (ele.status == 1) {
              self.orgbudgetdeatils = ele;
            }
          });
          this.get_deatils();
        }
      }
      //console.log(this.orgbudgetdeatils);
    },
    async get_deatils() {
      var inputData = {
        method_name: "BUDGET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETDETAILS",
          org_budget_id: this.orgbudgetdeatils.org_budget_id,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("get_deatils", responseData);
      if (responseData.data.status == "00") {
        //           for(let i=0;i< responseData.data.data.length;i++){
        //  this.unallocatedbudget = responseData.data.data[i].unallocated_budget;

        //         }
        if (responseData.data.data != null || responseData.data.data != "") {
          this.unallocatedbudget = responseData.data.data[0].unallocated_budget;

          this.budgetavailaible = responseData.data.data[0];
        }
      }
    },
    async createdeptbudget() {
      if (this.$refs.userdialogform.validate()) {
        if (
          this.dptbudgetid != "0" ||
          Number(this.budget) <= Number(this.unallocatedbudget)
        ) {
          //console.log(this.budget);
          // console.log(this.budgetavailaible.unallocated_budget);

          // if (
          //   parseInt(this.budget) >
          //   parseInt(this.budgetavailaible.unallocated_budget)
          // ) {
          //   this.userdialog = false;
          //   this.budgetwarningdialog = true;
          // } else {

          var inputData = {
            method_name: "BUDGET",
            page_no: 0,
            record_count: 0,
            page_size: 25,
            app_code: "CPORTAL",
            method_param: {
              action: "CDEPBUDG",
              // corp_id: this.$store.getters.get_corpid,
              dep_id: this.depdata.department_id,
              dep_budget: this.budget,
              org_budget_id: this.orgbudgetdeatils.org_budget_id,
            },
          };
          var responseData = await apiCall(inputData);
          if (responseData.data.status == "00") {
            this.getdepartment();
            this.get_deatils();
            this.userdialog = false;
            this.$refs.userdialogform.reset();
            this.$store.commit("snackbar/showMessage", {
              content: responseData.data.status_msg,
              color: "green",
            });
            // this.$refs.userdialogform.reset();
            // this.$refs.userdialogform.resetValidation();
            // this.$refs.userdialogform.reset();
            this.budget = "";
          } else {
            this.$refs.userdialogform.reset();
            this.$store.commit("snackbar/showMessage", {
              content: responseData.data.status_msg,
              color: "red",
            });
            this.budget = "";
            // this.$refs.userdialogform.resetValidation();
            // this.$refs.userdialogform.reset();
            // }
          }
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: "Exceeded the budget",
            color: "red",
          });
          this.$refs.userdialogform.reset();
          // this.userdialog = false;
        }
      }
    },
    closeuserdialog() {
      this.addBudGetDialoge = false;
      this.$refs.userdialogform.reset();
      this.budget = "";
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getdurationmon() {
      if (this.budgetavailaible.duration == "1") {
        return "Daily";
      } else if (this.budgetavailaible.duration == "2") {
        return "Weekly";
      } else if (this.budgetavailaible.duration == "3") {
        return "Monthly";
      }
    },
    async getdepartment() {
      this.overlay = true;
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GDMASTER",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.deptartmrntdata = responseData.data.data;
        }
        // this.overlay = false;
      }
      //console.log("depdata", responseData);
    },
    assignbudget(item) {
      // console.log(item);
      this.userdialog = true;
      this.departmentName = item.department_name;
      this.depdata = item;

      this.dptbudgetid = item.dep_budget_id;
      // console.log("dptbudgetid",this.dptbudgetid)
    },
  },
};
</script>
